import { TIPO_MOVIMENTACAO } from "constants/tipoColetas";

export const getDisabledEditPendency = (pendency) => {
  if (pendency.movementTypeId === TIPO_MOVIMENTACAO.MOVEMENT_BETWEEN_PASTURES) {
    return pendency.destiny.pastureExcluded || pendency.origin.pastureExcluded;
  }
  return pendency.movementTypeId === TIPO_MOVIMENTACAO.DEATH;
};
